import React from 'react';
import ReactDOM from 'react-dom';
import { Application } from './application';
import { AppProps } from './common/interfaces';

declare global {
  interface Window {
    _APPLICATION_INITIAL_STATE_: AppProps;
    _APPLICATION_LANGUAGE_OVERRIDES_: {
      [key: string]: string;
    };
    _SPA_APPLICATION_ENABLED_: boolean;
    AJAX_ROUTER_URL?: string;
    startCrowdicityApplication: () => void;
    applicationEventAction: (s: string) => void;
  }
}

export const startCrowdicityApplication = () => {
  const domNode = document.createElement('div');
  const alchemy = document.querySelector('#crowdicity-application');
  if (alchemy?.getAttribute('data-initialized') !== 'true') {
    alchemy?.appendChild(domNode);
    ReactDOM.render(<Application {...window._APPLICATION_INITIAL_STATE_} />, domNode);
    alchemy?.setAttribute('data-initialized', 'true');
  }
};

window.startCrowdicityApplication = startCrowdicityApplication;
